import { useMutation, useQueryClient } from '@tanstack/react-query';
import { couponService, type GetGoodsCouponResponse } from 'shared/src/api';
import { queryKey } from '../constant/queryKey';
import type { GoodsDiscountsResponse } from 'shared/src/api/goodsService/getGoodsDiscounts/types';
import { useGoodsSno } from '../hooks/useGoodsSno';

export const usePostRedeemCoupon = () => {
  const client = useQueryClient();
  const goodsSno = useGoodsSno();

  return useMutation({
    throwOnError: false,
    mutationFn: (params: { sno: number }) =>
      couponService
        .postRedeemCoupon(params.sno)
        .then(result => ({ ...result, ...params })),
    onSuccess: params => {
      client.invalidateQueries({
        queryKey: queryKey.goodsCoupon(goodsSno),
      });

      const goodsDiscountKey = queryKey.goodsDiscount(goodsSno);
      client.setQueryData<GoodsDiscountsResponse>(goodsDiscountKey, prev => {
        if (!prev) return undefined;

        return {
          ...prev,
          discount_groups: prev.discount_groups.map(group => {
            // if(group)
            if (group.display_type === 'ISSUABLE') {
              return {
                ...group,
                items: group.items.map(item => {
                  if (item.detail?.sno === params.sno) {
                    return {
                      ...item,
                      detail: {
                        ...item.detail,
                        is_issued: true,
                      },
                    };
                  }
                  return item;
                }),
              };
            }
            return group;
          }),
        };
      });
      const goodsCouponList = queryKey.goodsCouponList(goodsSno);
      client.setQueryData<GetGoodsCouponResponse>(goodsCouponList, prev => {
        if (!prev) return undefined;

        return prev.map(coupon => {
          return {
            ...coupon,
            is_issued: coupon.sno === params.sno ? true : coupon.is_issued,
          };
        });
      });
    },
  });
};
